import { CurrencyPipe, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectCurrencyInCommonState, selectLanguageInCommonState } from 'app/app-state.index';
import { WebRouletteSubscription } from 'app/public/model/web-roulette-subscription.model';
import { StripePaymentsService } from 'app/public/services/stripe-payments.service';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CurrencyType, Language, PaymentType } from 'app/shared/model/enums';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { StripeService } from 'ngx-stripe';
import { CommonService } from 'app/shared/services/common.service';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { AnalyticsService } from 'app/public/services/analytics.service';


@Component({
  selector: 'app-roulette-subscribtion',
  templateUrl: './roulette-subscribtion.component.html',
  styleUrls: ['./roulette-subscribtion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteSubscribtionComponent implements OnInit {
  rouletteId: any;
  rouletteSubscriptions: WebRouletteSubscription[];
  currency: CurrencyType;
  subscriptions = new Subscriber();
  curencyEnum = CurrencyType;
  paymentType = PaymentType;
  returnUrl: string
  colors = ['red', 'blue', 'green', 'yellow'];

  @Input()
  IsViewMode: boolean;

  constructor(private commonService: CommonService, private route: ActivatedRoute, private subscribtionService: SubscriptionService
    ,private store: Store<AppState>,
    private analytctis:AnalyticsService,
     private cdr: ChangeDetectorRef, private router: Router, private messageService: AdvMessageService, private location: Location
    , private stripePaymentsService: StripePaymentsService, private stripeService: StripeService, private localizationService: LocalizationService, 
    private AppAuthService: AppAuthService) {
    this.subscriptions.add(store.select(selectCurrencyInCommonState).subscribe(currency => {
      this.currency = currency;
    }));
    this.subscriptions.add(this.route.url.subscribe(urlsubscriber => {
      this.rouletteId = this.route.snapshot.params["rouletteId"];
      this.returnUrl = this.route.snapshot.params['returnUrl'];
      this.IsViewMode = this.IsViewMode || (this.route.snapshot.queryParams['viewMode'] ? true : false);
    }));
   
  }

  ngOnInit(): void {
    if (!this.IsViewMode) {
      this.commonService.changeCurrentPageHeader(this.localizationService.Translate('SUBSCRIPTION.TITLE'));
    }
    this.subscriptions.add(this.store.select(selectLanguageInCommonState).subscribe(language => {
      this.loadSubscriptions(language);
    }));
   this.sendViewSubscriptionEvent()
  }
  sendViewSubscriptionEvent(){
    // this.analytics.sendEvent('view-subscription');  
  }
  loadSubscriptions(language: Language) {
    let getSubscription;
    if (this.IsViewMode || !this.rouletteId) {
      getSubscription = this.subscribtionService.getAllSubscriptions(this.currency, language);
    } else {
      getSubscription = this.subscribtionService.getSubscriptions(this.rouletteId, this.currency, language);
    }
    getSubscription.subscribe(subscribtions => {    
      this.rouletteSubscriptions = subscribtions.sort((first, second) => { return first.Price - second.Price });
      let startWithIndex = this.rouletteSubscriptions.length === 4 ? 0 : 1;
      let index=startWithIndex;
      this.rouletteSubscriptions.forEach(subscription => {
        subscription = Object.assign(
          subscription,
          {
            color: this.colors[index===this.colors.length?index=startWithIndex:index++]
          }
        )
      });

      this.rouletteSubscriptions.forEach((subscription, index) => {
        const sizeKeys = ['SMALL', 'MEDIUM', 'LARGE'];
        subscription.campainSize = sizeKeys[index % sizeKeys.length]; 
        subscription.customersDatabase = sizeKeys[index % sizeKeys.length]; 

    });
      this.cdr.markForCheck();      
    })
  }
  selectSubscription(subscribtion: WebRouletteSubscription): Observable<any> {
  let paymentType=1
 
   if(subscribtion.IsYearlyPackage)
    paymentType=4
   else if(subscribtion.AutoRenewalPackage)
    paymentType=2
    if (!this.rouletteId)
      this.router.navigate(['roulette']);
    if (this.IsViewMode) {
      return;
    }

    this.commonService.blockScreen(true);
    if (subscribtion.IsFreePackage) {
      this.subscribtionService.buyFreeSubscription(this.rouletteId, subscribtion.PackageId).subscribe(response => {
        this.commonService.blockScreen(false);
        this.messageService.successMessage("SUBSCRIPTION.SUCCESS_BUY_TEST", true);
        this.router.navigate(['webplatform', 'my-roulettes'])
      })
      return;
    }
    this.subscribtionService.getMockPaymentStatus().subscribe((response: any) => {
      if (response.MockPaymentStatus) {
        this.subscribtionService.buyTestSubscription({
          rouletteId: this.rouletteId,
          productId: subscribtion.ProductId,
          packageId: subscribtion.PackageId,
          AutoRenwal:subscribtion.AutoRenewalPackage,
          PaymentType:PaymentType.oneTime
        }).subscribe((res: any) => {
          this.analytctis.sendEvent('buy-subscription', {
            packageId: subscribtion.PackageId,
            productId: subscribtion.ProductId,
            email: this.AppAuthService.authEmail,
            paymentType: paymentType,
            rouletteId: this.rouletteId,
          });     
          this.commonService.blockScreen(false);
          this.messageService.successMessage("SUBSCRIPTION.SUCCESS_BUY_TEST", true);
          this.router.navigate(['webplatform', 'my-roulettes'])
        })
      }
      else {
        this.analytctis.sendEvent('buy-subscription', {
          packageId: subscribtion.PackageId,
          productId: subscribtion.ProductId,
          email: this.AppAuthService.authEmail,
          paymentType: paymentType,
          rouletteId: this.rouletteId,
        });       
        this.stripePaymentsService.createSession(subscribtion.PackageId, subscribtion.ProductId, "", ""
          , "/webplatform/payment-success", "/webplatform/payment-failed", this.rouletteId, this.AppAuthService.authEmail,paymentType).subscribe(response => {            
            this.stripeService.redirectToCheckout({
              sessionId: response.SessionId,
            }).subscribe(data => {
              this.commonService.blockScreen(false);
            });
          });
      }
    }
  )
  }
  back(): void {
    if (this.returnUrl) {
      this.router.navigate([this.returnUrl])
    }
    else {
      this.location.back()
    }
  }
  ngOnDestroy() {
    this.commonService.clearCurrentPageHeader();
    this.subscriptions.unsubscribe();
  }

}
